import { render, staticRenderFns } from "./BienvenidoCard.vue?vue&type=template&id=1afc2286&"
import script from "./BienvenidoCard.vue?vue&type=script&lang=js&"
export * from "./BienvenidoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports